export const disease={
    Cattle_Trichiphyton_verrucosum: "Ringworm",
    Human_Trichophyton_rubrum: "Athlete’s foot, ringworm, onychomycosis",
    Human_Trichophyton_mentagrophytes: "Athlete’s foot, ringworm, onychomycosis",
    Human_Candida_albicans: 'Candidiasis',
    Human_Candida_auris: 'Candidiasis',
    Human_Histoplasma_capsulatum: 'Histoplasmosis',
    Human_Blastomyces_dermatitidis: 'Blastomycosis',
    Human_Cryptococcus_gattii: 'Cryptococcosis',
    Human_Aspergillus_fumigatus: 'Aspergillosis',
    Human_Streptococcus_pneumoniae: 'Pneumonia',
    Human_Escherichia_coli: 'Multiple infections',
    Human_Neisseria_meningitidis: 'Meningococcal meningitis',
    Human_Mycobacterium_tuberculosis: 'Tuberculosis',
    Human_Salmonella_typhimurium: 'Salmonellosis',
    Human_Salmonella_enteritidis: 'Salmonellosis',
    Human_Staphylococcus_aureus: 'Multiple infections',
    Human_Chlamydia_trachomatis: 'Chlamydia',
    Human_Shigella_sonnei: 'Shigellosis',
    Human_Shigella_dysenteriae: 'Shigellosis',
    Human_Shigella_flexneri: 'Shigellosis',
    Human_Treponema_pallidum: 'Syphilis',
    Human_Neisseria_gonorrhoeae: 'Gonorrhea',
    Human_Influenza_A_H3N2: 'Influenza',
    Human_Influenza_A_H1N1: 'Influenza',
    Human_Influenza_B: 'Influenza',
    Human_SARS_CoV_2: 'COVID-19',
    Human_Human_Immunodeficiency_Virus_1: 'AIDS',
    Human_Coxsackievirus: 'Meningitis',
    Human_Enterovirus_D68: 'Meningitis',
    Human_Human_papillomavirus_16: 'HPV',
    Human_Human_papillomavirus_18: 'HPV',
    Human_Herpes_simplex_virus_1: 'Herpes',
    Human_Herpes_simplex_virus_2: 'Herpes',
    Human_Human_rotavirus_A: 'Rotavirus',
    Human_Human_rotavirus_B: 'Rotavirus',
    Human_Human_rotavirus_C: 'Rotavirus',
    Human_Varicella_zoster_virus_Human_alphaherpesvirus_3: 'Chickenpox',
    Human_Norovirus_GI: 'Gastroenteritis',
    Human_Norovirus_GV: 'Gastroenteritis',
    Human_Hepatovirus_A: 'Hepatitis A',
    Human_Hepatovirus_B: 'Hepatitis B',
    Human_Hepatovirus_C: 'Hepatitis C',
    Cattle_Trichophyton_verrucosum: 'Ringworm',
    Cattle_Aspergillus_fumigatus: 'Mycotic placentitis',
    Cattle_Candida_albicans: 'Candidiasis',
    Cattle_Fusobacterium_necrophorum: 'Foot rot disease',
    Cattle_Mycobacterium_bovis: 'Tuberculosis',
    Cattle_Brucella_abortus: 'Brucellosis',
    Cattle_Bovine_viral_diarrhea_virus_1: 'Bovine viral diarrhea (BVD)',
    Cattle_Epizootic_hemorrhagic_disease_virus: 'Epizootic haemorrhagic disease (EHD)',
    Cattle_Mycobacterium_avium_subsp_Paratuberculosis: 'Johne‘s disease',
    Cattle_Foot_and_mouth_disease_virus: 'Foot-and-mouth disease',
    Cattle_Schmallenberg_virus: 'Schmallenberg virus disease',
    Cattle_Bovine_leukemia_virus: 'Bovine leukemia virus',
    Goat_Candida_albicans: 'Candidiasis',
    Goat_Cryptococcus_neoformans: 'Cryptococcosis',
    Goat_Cryptococcus_gattii: 'Cryptococcosis',
    Goat_Aspergillus_fumigatus: 'Aspergillosis',
    Goat_Trichophyton_verrucosum: 'Ringworm',
    Goat_Staphylococcus_aureus: 'Mastitis',
    Goat_Streptococcus_agalactiae: 'Mastitis',
    Goat_Clostridium_perfringens_B__C__D: 'Enterotoxemia',
    Goat_Mycoplasma_conjunctivae: 'Pinkeye',
    Goat_Brucella_melitensis: 'Brucellosis',
    Goat_Corynebacterium_pseudotuberculosis: 'Caseous lymphadenitis',
    Goat_Mycoplasma_capricolum_capripneumoniae: 'Contagious caprine pleuro-pneumonia (CCPP)',
    Goat_Dermatophilus_congolensis: 'Dermatophilosis',
    Goat_Fusobacterium_necrophorum: 'Foot rot disease',
    Goat_Dichelobacter_nodosus: 'Foot rot disease',
    Goat_Bacillus_anthracis: 'Anthrax',
    Goat_Pasteurella_multocida: 'Bronchopneumonia',
    Goat_Mannheimia_haemolytica: 'Bronchopneumonia',
    Goat_Mycoplasma_ovis: 'Eperythrozoonosis',
    Goat_Clostridium_tetani: 'Tetanus',
    Goat_Leptospira_interrogans: 'Leptospirosis',
    Goat_Coxiella_burnetii: 'Q fever',
    Goat_Chlamydia_abortus: 'Chlamydia',
    Goat_Caprine_arthritis_encephalitis_virus: 'Caprine Arthritis Encephalitis Syndrome (CAE) ',
    Goat_Orf_virus: 'Soremouth',
    Goat_Sheeppox_virus: 'Goat pox',
    Goat_Goat_pox_virus: 'Goat pox',
    Goat_Foot_and_mouth_disease_virus: 'Foot-and-mouth disease',
    Goat_Peste_des_petits_ruminants_virus: 'Peste des petits ruminants',
    Dog_Aspergillus_fumigatus: 'Nasal aspergillosis',
    Dog_Aspergillus_terreus: 'Disseminated aspergillosis',
    Dog_Aspergillus_niger: 'Disseminated aspergillosis',
    Dog_Candida_albicans: 'Candidiasis',
    Dog_Coccidioides_immitis: 'Coccidioidomycosis',
    Dog_Cryptococcus_neoformans: 'Cryptococcosis',
    Dog_Cryptococcus_gattii: 'Cryptococcosis',
    Dog_Histoplasma_capsulatum: 'Histoplasmosis',
    Dog_Blastomyces_dermatitidis: 'Blastomycosis',
    Dog_Sporothrix_schenckii: 'Sporotrichosis',
    Dog_Exophiala_dermatitidis: 'Phaeohyphomycosis',
    Dog_Cladophialophora_bantiana: 'Phaeohyphomycosis',
    Dog_Alternaria_alternata: 'Phaeohyphomycosis',
    Dog_Microsporum_canis: 'Ringworm',
    Dog_Leptospira_interrogans: 'Leptospirosis',
    Dog_Leptospira_kirschneri: 'Leptospirosis',
    Dog_Staphylococcus_pseudintermedius: 'Staph infection',
    Dog_Malassezia_pachydermatis: 'Yeast infection and otitis',
    Dog_Pseudomonas_aeruginosa: 'Skin infections and otitis',
    Dog_Schaalia_canis_Actinomyces_canis: 'Actinomycosis',
    Dog_Actinomyces_viscosus: 'Actinomycosis',
    Dog_Nocardia_asteroides: 'Nocardiosis',
    Dog_Nocardia_brasiliensis: 'Nocardiosis',
    Dog_Salmonella_typhimurium: 'Salmonellosis',
    Dog_Campylobacter_jejuni: 'Campylobacteriosis',
    Dog_Escherichia_coli: 'Multiple infections',
    Dog_Streptococcus_canis: 'Multiple infections',
    Dog_Streptococcus_equi_subsp_Zooepidemicus: 'Multiple infections',
    Dog_Pasteurella_multocida: 'Multiple infections',
    Dog_Bordetella_bronchiseptica: 'Respiratory infections',
    Dog_Morbillivirus_canis: 'Canine distemper',
    Dog_Influenza_A_H3N2: 'Canine influenza',
    Dog_Canid_herpesvirus_1: 'Canine herpes',
    Dog_Canine_parvovirus: 'Canine parvovirus',
    Dog_Canine_parainfluenza_virus: 'Canine parainfluenza virus',
    Dog_Lyssavirus_rabies: 'Rabies',
    Dog_Canine_adenovirus_1: 'Hepatitis ',
    Dog_Canine_adenovirus_2: 'Multiple respiratory infections',
    Cat_Aspergillus_fumigatus: 'Aspergillosis',
    Cat_Candida_albicans: 'Candidiasis',
    Cat_Coccidioides_immitis: 'Coccidioidomycosis',
    Cat_Cryptococcus_neoformans: 'Cryptococcosis',
    Cat_Cryptococcus_gattii: 'Cryptococcosis',
    Cat_Histoplasma_capsulatum: 'Histoplasmosis',
    Cat_Blastomyces_dermatitidis: 'Blastomycosis',
    Cat_Sporothrix_schenckii: 'Sporotrichosis',
    Cat_Exophiala_dermatitidis: 'Phaeohyphomycosis',
    Cat_Cladophialophora_bantiana: 'Phaeohyphomycosis',
    Cat_Alternaria_alternata: 'Phaeohyphomycosis',
    Cat_Microsporum_canis: 'Ringworm',
    Cat_Salmonella_typhimurium: 'Salmonellosis',
    Cat_Campylobacter_jejuni: 'Campylobacteriosis',
    Cat_Escherichia_coli: 'Multiple infections',
    Cat_Staphylococcus_felis: 'Multiple infections',
    Cat_Pasteurella_multocida: 'Multiple infections',
    Cat_Streptococcus_canis: 'Multiple infections',
    Cat_Streptococcus_equi_subsp_Zooepidemicus: 'Multiple infections',
    Cat_Staphylococcus_aureus: 'Staph infection',
    Cat_Bordetella_bronchiseptica: 'Respiratory infections',
    Cat_Staphylococcus_pseudintermedius: 'Skin infections',
    Cat_Chlamydophila_felis: 'Chlamydia',
    Cat_Leptospira_interrogans: 'Leptospirosis',
    Cat_Leptospira_borgpetersenii: 'Leptospirosis',
    Cat_Leptospira_kirschneri: 'Leptospirosis',
    Cat_Feline_immunodeficiency_virus: 'Feline immunodeficiency ',
    Cat_Feline_calicivirus: 'Respiratory infections',
    Cat_Felid_alphaherpesvirus_1: 'Feline herpesvirus',
    Cat_Feline_leukemia_virus: 'Feline leukemia',
    Cat_Feline_infectious_peritonitis_virus: 'Feline infectious peritonitis',
    Cat_Feline_panleukopenia_virus: 'Feline distemper',
    Cat_Lyssavirus_rabies: 'Rabies',
    Horse_Histoplasma_capsulatum_var_farciminosum: 'Epizootic lymphangitis',
    Horse_Exophiala_dermatitidis: 'Phaeohyphomycosis',
    Horse_Cladophialophora_bantiana: 'Phaeohyphomycosis',
    Horse_Alternaria_alternata: 'Phaeohyphomycosis',
    Horse_Sporothrix_schenckii: 'Sporotrichosis',
    Horse_Basidiobolus_ranarum: 'Basidiobolomycosis (horse only?)',
    Horse_Conidiobolus_coronatus: 'Conidiobolomycosis (horse only?)',
    Horse_Trichophyton_equinum: 'Ringworm',
    Horse_Trichophyton_mentagrophytes: "Ringworm",
    Horse_Candida_albicans: 'Candidiasis',
    Horse_Fusarium_verticillioides_moniliforme: 'Fumonisin toxicosis',
    Horse_Fusarium_proliferatum: 'Fumonisin toxicosis',
    Horse_Staphylococcus_aureus: 'Multiple infections',
    Horse_Staphylococcus_intermedius: 'Multiple infections',
    Horse_Streptococcus_equi_subsp_Zooepidemicus: 'Multiple infections',
    Horse_Pseudomonas_aeruginosa: 'Multiple infections',
    Horse_Escherichia_coli: 'Multiple infections',
    Horse_Rhodococcus_Prescotella_equi: 'Foal pneumonia',
    Horse_Neorickettsia_risticii: 'Potomac horse fever',
    Horse_Salmonella_typhimurium: 'Salmonellosis',
    Horse_Salmonella_agona: 'Salmonellosis',
    Horse_Streptococcus_equi_subsp_Equi: 'Strangles',
    Horse_Clostridium_tetani: 'Tetanus',
    Horse_Equine_influenza_virus: 'Equine influenza',
    Horse_West_Nile_virus: 'West Nile virus',
    Horse_Equine_encephalitis_virus: 'Equine encephalitis',
    Horse_Lyssavirus_rabies: 'Rabies',
    Horse_Equine_infectious_anemia_virus: 'Equine infectious anemia',
    Horse_Equine_rotavirus: 'Foal diarrhea',
    Horse_Equine_arteritis_virus: 'Equine viral arteritis',
    Horse_Equid_alphaherpesvirus_1: 'Equine herpesvirus',
    Horse_Equid_alphaherpesvirus_4: 'Equine herpesvirus',
    Pig_Trichophyton_verrucosum: 'Ringworm',
    Pig_Aspergillus_flavus: 'Aflatoxicosis',
    Pig_Aspergillus_parasiticus: 'Aflatoxicosis',
    Pig_Claviceps_purpurea: 'Ergotism',
    Pig_Fusarium_verticillioides_moniliforme: 'Fumonisin toxicosis',
    Pig_Fusarium_proliferatum: 'Fumonisin toxicosis',
    Pig_Fusarium_graminearum: 'Fumonisin toxicosis',
    Pig_Leptospira_pomona: 'Leptospirosis',
    Pig_Leptospira_grippotyphosa: 'Leptospirosis',
    Pig_Leptospira_autumnalis: 'Leptospirosis',
    Pig_Brucella_suis: 'Brucellosis',
    Pig_Salmonella_choleraesuis: 'Salmonellosis',
    Pig_Salmonella_typhimurium: 'Salmonellosis',
    Pig_Clostridium_perfringens_A: 'Enteritis',
    Pig_Clostridium_perfringens_C: 'Enteritis',
    Pig_Clostridium_difficile: 'Enteritis',
    Pig_Escherichia_coli: 'Multiple infections',
    Pig_Streptococcus_suis_1__2__14__24: 'Multiple infections',
    Pig_Brachyspira_hyodysenteriae: 'Swine disentery',
    Pig_Lawsonia_intracellularis: 'Porcine proliferative enteropathy',
    Pig_Staphylococcus_hyicus: 'Greasy pig',
    Pig_Erysipelothrix_rhusiopathiae: 'Erysipelas',
    Pig_Foot_and_mouth_disease_virus: 'Foot and mouth disease',
    Pig_Swine_influenza_virus_H1N1: 'Swine flu',
    Pig_Swine_influenza_virus_H3N2: 'Swine flu',
    Pig_African_swine_fever_virus: 'African swine fever',
    Pig_Classical_swine_fever_virus: 'Classical swine fever',
    Pig_Suid_alphaherpesvirus_1: 'Pseudorabies',
    Pig_Rotavirus_A: 'Rotavirus',
    Pig_Rotavirus_B: 'Rotavirus',
    Pig_Rotavirus_C: 'Rotavirus',
    Pig_Transmissible_gastroenteritis_virus: 'Transmissible gastroenteritis',
    Pig_Porcine_epidemic_diarrhea_virus: 'Porcine epidemic diarrhea',
    Pig_Porcine_circovirus_type_2: 'Porcine dermatopathy and nephropathy syndrome ',
    Pig_Porcine_reproductive_and_respiratory_syndrome_virus_1: 'Porcine reproductive and respiratory syndrome virus 1',
    Pig_Porcine_reproductive_and_respiratory_syndrome_virus_2: 'Porcine reproductive and respiratory syndrome virus 2',
    Water_Buffalo_Trichophyton_verrucosum: 'Ringworm',
    Water_Buffalo_Anaplasma_marginale: 'Anaplasmosis',
    Water_Buffalo_Bacillus_anthracis: 'Anthrax',
    Water_Buffalo_Brucella_abortus: 'Brucellosis',
    Water_Buffalo_Mycobacterium_bovis: 'Tuberculosis',
    Water_Buffalo_Pasteurella_multocida: 'Hemorrhagic septicemia',
    Water_Buffalo_Mycobacterium_avium_subsp_Paratuberculosis: 'Johne‘s disease',
    Water_Buffalo_Leptospira_interrogans: 'Leptospirosis',
    Water_Buffalo_Leptospira_borgpetersenii: 'Leptospirosis',
    Water_Buffalo_Bluetongue_virus: 'Bluetongue',
    Water_Buffalo_Bovine_viral_diarrhea_virus_1: 'Bovine viral diarrhea',
    Water_Buffalo_Bovine_viral_diarrhea_virus_2: 'Bovine viral diarrhea',
    Water_Buffalo_Macavirus_alcelaphinegamma1: 'Malignant catarrhal fever',
    Water_Buffalo_Alcelaphine_gammaherpesvirus_2: 'Malignant catarrhal fever',
    Water_Buffalo_Macavirus_ovinegamma2: 'Malignant catarrhal fever',
    Water_Buffalo_Macavirus_caprinegamma2: 'Malignant catarrhal fever',
    Water_Buffalo_Foot_and_mouth_disease_virus: 'Foot-and-mouth disease',
    Water_Buffalo_Rinderpest_virus: 'Rinderpest',
    Water_Buffalo_Bovine_alphaherpesvirus_1: 'Infectious Bovine Rhinotracheitis',
    Water_Buffalo_Lumpy_skin_disease_virus: 'Lumpy Skin Disease',
    Water_Buffalo_Schmallenberg_virus: 'Schmallenberg virus',
    Water_Buffalo_Bovine_Ephemeral_Fever_virus: 'Bovine Ephemeral Fever',
    Water_Buffalo_Bovine_papillomavirus_1__2__5: 'Papillomatosis',
    Sheep_Candida_albicans: 'Candidiasis',
    Sheep_Cryptococcus_neoformans: 'Cryptococcosis',
    Sheep_Cryptococcus_gattii: 'Cryptococcosis',
    Sheep_Aspergillus_fumigatus: 'Aspergillosis',
    Sheep_Trichophyton_verrucosum: 'Ringworm',
    Sheep_Pithomyces_chartarum: 'Facial eczema',
    Sheep_Corynebacterium_pseudotuberculosis: 'Caseous lymphadenitis',
    Sheep_Dichelobacter_nodosus: 'Footrot disease',
    Sheep_Fusobacterium_necrophorum: 'Footrot disease',
    Sheep_Listeria_monocytogenes: 'Listeriosis',
    Sheep_Mycobacterium_avium_subsp_Paratuberculosis: 'Johne‘s disease',
    Sheep_Pasteurella_multocida: 'Bronchopneumonia',
    Sheep_Mannheimia_haemolytica: 'Bronchopneumonia',
    Sheep_Mycoplasma_ovis: 'Eperythrozoonosis',
    Sheep_Clostridium_perfringens_B: 'Enterotoxemia',
    Sheep_Clostridium_perfringens_C: 'Enterotoxemia',
    Sheep_Clostridium_perfringens_D: 'Enterotoxemia',
    Sheep_Clostridium_tetani: 'Tetanus',
    Sheep_Coxiella_burnetii: 'Q fever',
    Sheep_Chlamydia_abortus: 'Chlamydia',
    Sheep_Bluetongue_virus: 'Bluetongue',
    Sheep_Epizootic_hemorrhagic_disease_virus: 'Epizootic hemorrhagic disease',
    Sheep_Foot_and_mouth_disease_virus: 'Foot-and-mouth disease',
    Sheep_Visna_maedi_virus: 'Maedi Visna',
    Sheep_Schmallenberg_virus: 'Schmallenberg virus',
    Sheep_Orf_virus: 'Soremouth',
    Honey_Bee_Ascosphaera_apis: 'Chalkbrood disease',
    Honey_Bee_Nosema_apis: 'Nosema',
    Honey_Bee_Paenibacillus_larvae: 'American Foulbrood ',
    Honey_Bee_Melissococcus_plutonius: 'European Foulbrood',
    Honey_Bee_Sacbrood_virus: 'Sacbrood',
    Honey_Bee_Chronic_bee_paralysis_virus: 'Chronic Bee Paralysis',
    Honey_Bee_Black_queen_cell_virus: 'Black Queen Cell Virus',
    Honey_Bee_Deformed_Wing_Virus: 'Deformed Wing Virus',
    Honey_Bee_Acute_bee_paralysis_virus: 'Acute bee paralysis ',
    Chicken_Aspergillus_fumigatus: 'Aspergillosis',
    Chicken_Aspergillus_flavus: 'Aspergillosis',
    Chicken_Candida_albicans: 'Candidiasis',
    Chicken_Dactylaria_Verruconis_gallopava: 'Dactylariosis',
    Chicken_Escherichia_coli: 'Colibacillosis',
    Chicken_Mycoplasma_gallisepticum: 'Mycoplasmosis',
    Chicken_Salmonella_pullorum: 'Salmonellosis',
    Chicken_Pasteurella_multocida: 'Fowl cholera',
    Chicken_Avian_coronavirus: 'Infectious bronchitis',
    Chicken_Fowlpox_virus: 'Fowlpox',
    Chicken_Marek_s_disease_virus: 'Marek\'s disease',
    Chicken_Newcastle_disease_virus: 'Newcastle disease',
    Chicken_Influenza_A: 'Avian influenza',
    Chicken_Tremovirus_A: 'Tremovirus',
    Domestic_Yak_Trichophyton_verrucosum: 'Ringworm',
    Domestic_Yak_Cryptosporidium_bovis: 'Cryptosporidiosis',
    Domestic_Yak_Cryptosporidium_andersoni: 'Cryptosporidiosis',
    Domestic_Yak_Cryptosporidium_parvum: 'Cryptosporidiosis',
    Domestic_Yak_Cryptosporidium_ryanae: 'Cryptosporidiosis',
    Domestic_Yak_Bacillus_anthracis: 'Anthrax',
    Domestic_Yak_Brucella_abortus: 'Brucellosis',
    Domestic_Yak_Brucella_melitensis: 'Brucellosis',
    Domestic_Yak_Escherichia_coli: 'Calf scours',
    Domestic_Yak_Mycoplasma_mycoides: 'Contagious bovine pleuropneumonia',
    Domestic_Yak_Chlamydophila_psittaci: 'Chlamydia',
    Domestic_Yak_Staphylococcus_aureus: 'Mastitis',
    Domestic_Yak_Streptococcus_agalactiae: 'Mastitis',
    Domestic_Yak_Salmonella_typhimurium: 'Salmonellosis',
    Domestic_Yak_Salmonella_dublin: 'Salmonellosis',
    Domestic_Yak_Salmonella_newport: 'Salmonellosis',
    Domestic_Yak_Clostridium_tetani: 'Tetanus',
    Domestic_Yak_Mycobacterium_bovis: 'Tuberculosis',
    Domestic_Yak_Foot_and_mouth_disease_virus: 'Foot-and-mouth disease',
    Domestic_Yak_Epizootic_hemorrhagic_disease_virus_2: 'Epizootic hemorrhagic disease',
    Domestic_Yak_Lumpy_skin_disease_virus: 'Lumpy Skin Disease',
    Domestic_Yak_Bovine_alphaherpesvirus_1: 'Infectious Bovine Rhinotracheitis',
    Domestic_Yak_Rinderpest_virus: 'Rinderpest',
    Domestic_Yak_Bovine_viral_diarrhea_virus_1: 'Bovine viral diarrhea',
    Domestic_Yak_Bovine_viral_diarrhea_virus_2: 'Bovine viral diarrhea',
}


